export interface EpsInitRequest {
  _csrf: string;
  language: string;
}

export enum EpsInitResponseError {
  AUTHORIZATION_REQUEST_ERROR = 'authorization_request_error',
  INVALID_REQUEST = 'invalid_request',
  SERVER_ERROR = 'server_error'
}

export enum EpsErrorCode {
  AUTHORIZATION_REQUEST_ERROR = 'AUTHORIZATION_REQUEST_ERROR',
  INTERNAL_ERROR = 'INTERNAL_ERROR',
  EPS_ERROR = 'EPS_ERROR'
}